import { useState } from 'react';

export type SortDirection = 'desc' | 'asc';
export type Sorting<T extends string | number> = {
  direction: SortDirection;
  field: T;
};

/**
 * Holder styr på side og sortering. Selve hentingen gjøres av useFetch hos
 * kaller, ved at currentPage, pageSize og sorting legges i dependencies.
 */
export function useSortedPaging<T extends string | number>(
  initialSorting: Sorting<T>,
  initialPage: number = 1,
  pageSize: number = 20
): [
  number,
  number,
  number,
  Sorting<T>,
  () => void,
  () => void,
    React.Dispatch<React.SetStateAction<number>>,
    React.Dispatch<React.SetStateAction<Sorting<T>>>
] {
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [sorting, setSorting] = useState<Sorting<T>>(initialSorting);
  const startIndex = currentPage > 0 ? (currentPage - 1) * pageSize : 0;

  const onNextPage = () => setCurrentPage(currentPage + 1);
  const onPreviousPage = () =>
    setCurrentPage(currentPage > 0 ? currentPage - 1 : 0);

  return [
    startIndex,
    currentPage,
    pageSize,
    sorting,
    onNextPage,
    onPreviousPage,
    setCurrentPage,
    setSorting
  ];
}
